"use client";

import React from "react";
import { ArrowRight, CircleCheck as CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Safety() {
  return <section id="safety-information" data-nav="light" className="relative w-full border-t border-border bg-background py-16 text-foreground md:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="mb-12 border-b border-border pb-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="flex h-7 w-7 items-center justify-center bg-secondary text-secondary-foreground text-xs font-mono">
                SEC
              </span>
              <span className="font-mono text-xs tracking-wider uppercase text-muted-foreground">
                OPERATIONAL PROTOCOLS // REV 2.4
              </span>
            </div>
          </div>
          <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight uppercase sm:text-4xl lg:text-5xl">
            Mechanical Bull Safety & Operating Information
          </h2>
          <div className="mt-3 max-w-3xl space-y-3 text-base text-muted-foreground sm:text-lg">
            <p>
              Safety should be based on the exact equipment, its manufacturer's instructions and the rules that apply where the machine operates.
            </p>
            <p>
              We avoid treating every mechanical bull as though it uses identical controls, sensors or operating procedures.
            </p>
            <p>
              Before operation, owners and operators should understand the machine's documented:
            </p>
            <ul className="list-disc pl-5 space-y-1 marker:text-primary">
              <li>operating controls</li>
              <li>emergency stop</li>
              <li>rider restrictions</li>
              <li>safety-area requirements</li>
              <li>setup instructions</li>
              <li>inspection requirements</li>
              <li>maintenance guidance</li>
            </ul>
            <p>
              Manufacturer documentation should take priority for model-specific procedures.
            </p>
            <p>
              For broader amusement-equipment information, industry resources such as <strong className="font-semibold text-foreground">IAAPA</strong> and <strong className="font-semibold text-foreground">ASTM International Committee F24</strong> provide useful context around amusement ride and device safety standards.
            </p>
          </div>
        </div>

        {/* Split Content Grid */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Left Column: Guidelines & Actions */}
          <div className="flex flex-col justify-between space-y-8 lg:col-span-7">
            {/* Operator Guidelines Box */}
            <div className="border border-border bg-card p-6">
              <div className="flex items-start gap-4">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
                <div className="space-y-1">
                  <h3 className="font-serif text-base font-bold uppercase tracking-tight">
                    Operator Responsibility & Training Requirements
                  </h3>
                  <p className="text-xs leading-relaxed text-muted-foreground">
                    Operators and venue staff should strictly follow the documented procedures, training guidelines, and manufacturer instructions developed for the exact equipment model they operate, rather than relying on generalized assumptions.
                  </p>
                </div>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-4 border-t border-border pt-4">
                <Button asChild className="rounded-none bg-primary px-6 py-2.5 font-serif text-sm font-semibold tracking-wider text-primary-foreground uppercase hover:bg-primary/90">
                  <Link to="/SetupSafetyAndMaintenancePage">
                    View Full Safety Manual
                    <ArrowRight className="ml-1.5 h-4 w-4" />
                  </Link>
                </Button>
                <Button asChild variant="outline" className="rounded-none border-foreground px-5 py-2.5 font-serif text-sm font-semibold tracking-wider uppercase text-foreground hover:bg-foreground hover:text-background">
                  <Link to="/ContactPage">
                    Technical Inquiries
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {/* Right Column: Industrial Media Spec Frame */}
          <div className="flex flex-col lg:col-span-5" />
        </div>
      </div>
    </section>;
}